import React from 'react'
import './GoodBeat.css'

const GoodBeat = ({name, handleGoodBeat}) => {
  return (
    <button className='goodBeatButton' onClick={() => handleGoodBeat(name)}>
      {name}
    </button>
  )
}

export default GoodBeat


// WEBPACK FOOTER //
// ./src/GoodBeat/GoodBeat.js